var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.productConfiguratorTitle && _vm.product_configurator_id)?_c('span',[_vm._v(_vm._s(_vm.$t(_vm.productConfiguratorTitle)))]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }